export const dropDownMenuStyles = {
  width: 230,
};

export const iconWrapperStyles = theme => ({
  margin: theme.spacing(0.5, 2, 0, 0),
});

export const intitalStepStyles = theme => ({
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  display: 'flex',
  flexDirection: 'column',
  height: 'calc(100% - 68px)',
  overflowY: 'auto',
  padding: theme.spacing(4, 3, 0),
});

export const selectionButtonStyles = theme => ({
  '&:last-child': {
    marginBottom: theme.spacing(3),
  },
  ...theme.typography.h7,
  alignItems: 'center',
  backgroundColor: theme.palette.surface.white,
  border: `2px solid ${theme.palette.primary.main}`,
  borderRadius: 0.5,
  color: theme.palette.primary.dark,
  cursor: 'pointer',
  display: 'inline-flex',
  fontWeight: 300,
  height: 80,
  letterSpacing: 0.5,
  lineHeight: '24px',
  marginBottom: theme.spacing(2),
  outline: 'none',
  padding: theme.spacing(2, 2, 2, 3),
  textAlign: 'left',
});

export const selectionButtonSelectedStyles = theme => ({
  backgroundColor: theme.palette.primary.lighter,
  border: 'none',
  borderRadius: 0.5,
});

export const singleFilterStyles = theme => ({
  marginBottom: theme.spacing(3.5),
  width: '100%',
});

export const titleStyles = theme => ({
  marginBottom: theme.spacing(2),
});
